import Cookies from "universal-cookie";

export const getAccessToken = () => new Cookies().get('access_token');
